/**
 * Skip Links per migliorare la navigazione da tastiera e screen reader
 */
const AccessibilitySkipLinks = () => {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Salta al contenuto principale
      </a>
      <a href="#navigation" className="skip-link">
        Salta alla navigazione
      </a>
      <a href="#footer" className="skip-link">
        Salta al footer
      </a>
    </>
  );
};

export default AccessibilitySkipLinks;
